export enum CredentialPurpose {
  CNPS = 'CNPS',
  DGI = 'DGI',
}
